(() => {
  const scriptNode = Array.from(document.scripts).find((script) => script.src && script.src.includes('lhc-frame-details.js'));
  const assetUrl = (filename) => {
    if (!scriptNode || !scriptNode.src) return filename;
    return scriptNode.src.replace(/lhc-frame-details\.js(?:\?.*)?$/, filename);
  };

  // Exact Printumo canvas frame photography, hosted in LunarHeartCo's Shopify Files.
  const printumoFrameImages = {
    'no frame': { type: 'no-frame', url: 'https://cdn.shopify.com/s/files/1/0944/1823/9830/files/lhc-printumo-canvas-frame-no-frame.jpg?v=1791721009', alt: 'Printumo stretched canvas corner without an external decorative frame' },
    oak: { type: 'oak', url: 'https://cdn.shopify.com/s/files/1/0944/1823/9830/files/lhc-printumo-canvas-frame-oak.jpg?v=1791721014', alt: 'Printumo oak floater frame corner on stretched canvas' },
    'dark oak': { type: 'dark-oak', url: 'https://cdn.shopify.com/s/files/1/0944/1823/9830/files/lhc-printumo-canvas-frame-dark-oak.jpg?v=1791721020', alt: 'Printumo dark oak floater frame corner on stretched canvas' },
    white: { type: 'white', url: 'https://cdn.shopify.com/s/files/1/0944/1823/9830/files/lhc-printumo-canvas-frame-white.jpg?v=1791721031', alt: 'Printumo white floater frame corner on stretched canvas' },
    black: { type: 'black', url: 'https://cdn.shopify.com/s/files/1/0944/1823/9830/files/lhc-printumo-canvas-frame-black.jpg?v=1791721035', alt: 'Printumo black floater frame corner on stretched canvas' }
  };
  const isPrintumoWallStudiesCanvas = (element) => {
    const section = element?.closest('.lhc-premium-product');
    const handle = section?.querySelector('variant-selects')?.dataset.productHandle || '';
    return /^wall-studies-.*-canvas$/.test(handle) || handle === 'mediterranean-studies-salt-stone-canvas' || handle === 'mediterranean-studies-the-terrace-canvas' || handle === 'mediterranean-studies-the-hour-canvas' || handle === 'mediterranean-studies-the-shore-canvas' || handle === 'mediterranean-studies-windswept-canvas' || handle === 'mediterranean-studies-the-current-canvas' || handle === 'mediterranean-studies-the-blue-distance-canvas' || handle === 'mediterranean-studies-the-wild-light-canvas' || handle === 'mediterranean-studies-the-clearing-canvas' || handle === 'mediterranean-studies-the-sunshower-canvas' || handle === 'mediterranean-studies-high-summer-canvas' || handle === 'mediterranean-studies-the-red-veil-canvas' || handle === 'mediterranean-studies-crimson-undertow-canvas' || handle === 'mediterranean-studies-black-tide-canvas' || handle === 'mediterranean-studies-the-sail-canvas' || handle === 'mediterranean-studies-the-passage-canvas' || /^figure-study-[a-z0-9-]+-canvas(?:-art)?$/.test(handle);
  };

  const getFrameType = (label) => {
    const value = String(label || '').toLowerCase();
    if (value.includes('dark')) return 'dark';
    if (value.includes('black')) return 'black';
    return 'wood';
  };

  const getMaterialType = (label) => {
    const value = String(label || '').toLowerCase();
    if (value.includes('dark')) return 'dark';
    if (value.includes('black')) return 'black';
    if (value.includes('wood') || value.includes('natural') || value.includes('oak')) return 'wood';
    return null;
  };

  const getDescription = (type) => {
    if (type === 'dark') return 'Pine wood · dark wood finish';
    if (type === 'black') return 'Pine wood · black finish';
    return 'Pine wood · natural wood finish';
  };

  const getDetailAsset = (type) => {
    if (type === 'dark') return 'lhc-gelato-frame-dark-wood-v5.jpg';
    if (type === 'black') return 'lhc-gelato-frame-black.jpg';
    return 'lhc-gelato-frame-wood.jpg';
  };

  const createVisualPair = (image, label, type) => {
    const visuals = document.createElement('div');
    visuals.className = 'lhc-frame-card__visuals';

    const full = document.createElement('div');
    full.className = 'lhc-frame-card__full';
    image.classList.add('lhc-frame-card__image');
    full.appendChild(image);

    const detail = document.createElement('figure');
    detail.className = 'lhc-frame-card__detail';

    const detailWindow = document.createElement('div');
    detailWindow.className = `lhc-frame-card__detail-window lhc-frame-card__detail-window--${type}`;

    const detailImage = document.createElement('img');
    detailImage.className = 'lhc-frame-card__detail-image';
    detailImage.src = assetUrl(getDetailAsset(type));
    detailImage.alt = `${label} frame finish close-up`;
    detailImage.loading = 'eager';
    detailImage.decoding = 'async';
    detailWindow.appendChild(detailImage);

    const caption = document.createElement('figcaption');
    caption.textContent = 'Frame finish detail';
    detail.append(detailWindow, caption);
    visuals.append(full, detail);
    return visuals;
  };

  const enhanceFrameGuide = (scope = document) => {
    const dialogs = [];
    if (scope.matches && scope.matches('dialog[id^="LhcFrameGuide-"]')) dialogs.push(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('dialog[id^="LhcFrameGuide-"]').forEach((dialog) => dialogs.push(dialog));
    }

    dialogs.forEach((dialog) => {
      dialog.classList.add('lhc-frame-guide-redesign');
      dialog.querySelectorAll('.lhc-guide-option-title').forEach((heading) => { heading.hidden = true; });

      const grid = dialog.querySelector('.lhc-frame-grid');
      if (!grid) return;

      // For Printumo-produced Wall Studies, show all five genuine frame
      // corner photographs, including unframed canvas and white frame.
      // Keep the other collections' approved frame guides untouched.
      if (isPrintumoWallStudiesCanvas(dialog)) {
        grid.querySelectorAll('.lhc-frame-card').forEach((card) => {
          const heading = card.querySelector('h3');
          const frame = printumoFrameImages[heading?.textContent.trim().toLowerCase() || ''];
          if (!frame) return;
          let image = card.querySelector(':scope > img');
          if (!image) {
            image = document.createElement('img');
            card.insertBefore(image, heading);
          }
          image.src = frame.url;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.alt = frame.alt;
          image.loading = 'eager';
          image.decoding = 'async';
          card.classList.add('lhc-frame-card--printumo');
        });
        // The Gelato construction explanation applies to paper framing,
        // not the Printumo stretched/floater canvas product.
        dialog.querySelectorAll('.lhc-frame-construction').forEach((item) => item.remove());
        return;
      }

      const seen = new Set();
      grid.querySelectorAll('.lhc-frame-card').forEach((card) => {
        const heading = card.querySelector('h3');
        if (!heading) return;

        const label = heading.textContent.trim();
        const key = label.toLowerCase();
        if (seen.has(key)) {
          card.remove();
          return;
        }
        seen.add(key);

        if (card.dataset.lhcFrameEnhanced === 'true') return;
        const image = card.querySelector(':scope > img');
        if (!image) return;

        const type = getFrameType(label);
        card.dataset.frameType = type;
        card.dataset.lhcFrameEnhanced = 'true';

        const description = document.createElement('p');
        description.className = 'lhc-frame-card__description';
        description.textContent = getDescription(type);
        heading.insertAdjacentElement('afterend', description);
        description.insertAdjacentElement('afterend', createVisualPair(image, label, type));
      });

      dialog.querySelectorAll('.lhc-frame-construction').forEach((item) => item.remove());
      const construction = document.createElement('div');
      construction.className = 'lhc-frame-construction';
      construction.innerHTML = '<span class="lhc-frame-construction__label">Frame construction</span><p>Durable pine frame · Clear shatterproof plexiglass</p><small>Frame grain and tone may vary slightly by production location.</small>';
      grid.insertAdjacentElement('afterend', construction);
    });
  };

  const enhanceFrameSelectors = (scope = document) => {
    const fieldsets = [];
    if (scope.matches && scope.matches('.lhc-frame-options')) fieldsets.push(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('.lhc-frame-options').forEach((fieldset) => fieldsets.push(fieldset));
    }

    fieldsets.forEach((fieldset) => {
      fieldset.classList.add('lhc-frame-options--visual');

      fieldset.querySelectorAll('input[type="radio"] + label').forEach((label) => {
        if (label.dataset.lhcMaterialSwatch === 'true') return;

        const nameNode = label.querySelector('.lhc-option-value');
        const labelText = nameNode ? nameNode.textContent.trim() : label.textContent.trim();
        const printumoFrame = isPrintumoWallStudiesCanvas(fieldset)
          ? printumoFrameImages[labelText.toLowerCase()]
          : null;
        const type = printumoFrame?.type || getMaterialType(labelText);
        if (!type) return;

        const swatch = document.createElement('span');
        swatch.className = `lhc-frame-material-swatch lhc-frame-material-swatch--${type}`;
        swatch.setAttribute('aria-hidden', 'true');

        const image = document.createElement('img');
        image.src = printumoFrame ? printumoFrame.url : assetUrl(getDetailAsset(type));
        image.alt = '';
        image.loading = 'eager';
        image.decoding = 'async';
        swatch.appendChild(image);

        label.prepend(swatch);
        label.classList.add('lhc-frame-swatch-option');
        label.dataset.lhcMaterialSwatch = 'true';
      });
    });
  };

  const observedSections = new WeakSet();
  const observeFrameSelectorUpdates = (section) => {
    if (!section || observedSections.has(section)) return;
    observedSections.add(section);

    let refreshQueued = false;
    const observer = new MutationObserver((mutations) => {
      const relevantChange = mutations.some((mutation) => {
        const target = mutation.target?.nodeType === 1 ? mutation.target : mutation.target?.parentElement;
        if (target?.closest?.('variant-selects, .lhc-frame-options')) return true;

        return Array.from(mutation.addedNodes || []).some((node) => {
          if (node.nodeType !== 1) return false;
          return node.matches?.('variant-selects, .lhc-frame-options') ||
            node.querySelector?.('variant-selects, .lhc-frame-options');
        });
      });

      if (!relevantChange || refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(() => {
        refreshQueued = false;
        enhanceFrameSelectors(section);
      });
    });

    observer.observe(section, { childList: true, subtree: true });
  };

  const initializeSection = (section) => {
    if (!section) return;
    enhanceFrameSelectors(section);
    observeFrameSelectorUpdates(section);
  };

  const run = () => {
    enhanceFrameGuide(document);
    enhanceFrameSelectors(document);
    document.querySelectorAll('.lhc-premium-product').forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', (event) => {
    enhanceFrameGuide(event.target);
    enhanceFrameSelectors(event.target);

    if (event.target.matches?.('.lhc-premium-product')) initializeSection(event.target);
    event.target.querySelectorAll?.('.lhc-premium-product').forEach(initializeSection);
  });

  document.addEventListener('change', (event) => {
    const section = event.target.closest('.lhc-premium-product');
    if (!section || !event.target.closest('variant-selects')) return;

    // Fallback for delayed Shopify variant HTML replacement. The MutationObserver
    // handles normal re-renders; this catches unusually late updates as well.
    window.setTimeout(() => enhanceFrameSelectors(section), 180);
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lhc-dialog-open^="LhcFrameGuide-"]');
    if (!trigger) return;
    window.setTimeout(run, 0);
  });
})();
